import { AccountPermission } from 'modules/permissions/constants';
import { useAccount } from 'modules/account/hooks/useAccount';
import { useCheckAccountPermission } from 'modules/account/hooks/useCheckAccountPermission';

import { useAllowedJWTsCount } from './useAllowedJWTsCount';
import { useJWTManagerPermissions } from './useJWTManagerPermissions';

export interface UseJwtManagerInitializerParams {
  skipFetching?: boolean;
}

export const useJwtManagerInitializer = ({
  skipFetching = false,
}: UseJwtManagerInitializerParams) => {
  const hasAccess = useCheckAccountPermission({
    permission: AccountPermission.JwtManagerRead,
  });

  const { group } = useAccount();

  useAllowedJWTsCount({ group, skipFetching: skipFetching || !hasAccess });

  return useJWTManagerPermissions();
};
